import { apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  dealerPlaces: [],
}

const createDealerPlacesSlice = (set, get) => ({
  ...initialState,
  fetchDealerPlaces: async (dealerId, callback) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/dealer_places`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set((state) => ({ dealerPlaces: data.data }))
    } catch (err) {
      get().logError('Unable to fetch dealer place.', err)
    } finally {
      callback()
    }
  },
  createDealerPlace: async (dealerId, body) => {
    set(() => ({ isCreatingDealerPlace: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/dealer_places`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify({ dealer_place: body })
        }
      )
      const data = await response.json()

      if (response.ok) {
        get().setSuccessMessage('Dealer place successfully created')
        get().fetchDealerPlaces(dealerId, () => {})
      } else {
        get().setErrMessage(data.errors?.[0] || 'Unable to create dealer place')
      }
    } catch (err) {
      get().logError('There was an error creating this dealer place.', err)
    } finally {
      set(() => ({ isCreatingDealerPlace: false }))
    }
  },
  resetDealerPlacesSlice: () => set(initialState)
})

export default createDealerPlacesSlice